import { Injectable } from '@angular/core';
import { DataService, ObjectKey, PersistMode, PersistObjectsModel, TargetObjectData } from '@barthauer/abc/core/data';
import { GeoDsDocument } from '@barthauer/custom/xmt-models';
import { Observable, Subject } from 'rxjs';
import { ObjectKeys } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private uploadData: Subject<GeoDsDocument> = new Subject();
  public uploadData$: Observable<GeoDsDocument> = this.uploadData.asObservable();

  private uploadMultipleData: Subject<GeoDsDocument> = new Subject();
  public uploadMultipleData$: Observable<GeoDsDocument> = this.uploadMultipleData.asObservable();

  public currentDocument: GeoDsDocument = new GeoDsDocument(null);

  constructor(private coreDataService: DataService) {}

  public onFileChanged(event, document: GeoDsDocument): void {
    let documentSource = '';
    if (event?.value.length !== 0) {
      const files: any[] = Array.from(event.value);
      files.forEach((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(new Blob([file]));
        let doc = { ...document };
        reader.onloadend = () => {
          documentSource = reader.result as string;
          doc.Object = documentSource;
          doc.FileName = file?.name ? file.name : '';
          doc.Designation = file?.name?.split('.')[0];
          doc.Reserve2 = file['size'] / 1000 + ' KB';
          this.uploadMultipleData.next(doc);
        };
      });
    }
  }

  public persistUploadFile(document: GeoDsDocument): Observable<any> {
    return this.persistUploadFiles([document]);
  }

  public persistUploadFiles(documents: GeoDsDocument[]): Observable<any> {
    const filesPersistQuery: TargetObjectData[][] = [[]];

    documents.forEach((_document) => {
      const filePersistObjectData: TargetObjectData = new TargetObjectData();
      filePersistObjectData.Mode = PersistMode.Insert;
      filePersistObjectData.ObjectKey = new ObjectKey();
      filePersistObjectData.ObjectKey.ObjectType = ObjectKeys.DOCUMENT;
      filePersistObjectData.TargetColumns = [
        { Name: 'Object', Value: this.getBinaryStringFromUrl(_document.Object) },
        { Name: 'FileName', Value: _document.FileName },
        { Name: 'ParentId', Value: _document.ParentId },
        { Name: 'Designation', Value: _document.Designation },
        { Name: 'IdRefPersonInsert', Value: sessionStorage.getItem('profileId') },
        { Name: 'Kind', Value: _document.Kind },
        { Name: 'Reserve2', Value: _document.Reserve2 },
        { Name: 'ParentObjectType', Value: _document.ParentObjectType },
      ];
      filesPersistQuery[0].push(filePersistObjectData);
    });

    const query: PersistObjectsModel = new PersistObjectsModel();
    query.Objects = filesPersistQuery;
    return this.coreDataService.executePersistObjectsQuery(query);
  }

  private getBinaryStringFromUrl(url: string): string {
    return url?.split(',')[1];
  }
}
